import React from 'react';
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import DataTable from '../DataTable';
import ViewAllButton from '../DocumentViewer/ViewAllButton';
import CommentsButton from '../Comments/CommentsButton';
import Store from "../../store/Store";
import rootReducer from "../../store/Reducers";
import { GlobalSearchResult } from './GlobalSearch';

const reduxStore = Store({}, rootReducer);

type GlobalSearchResultGridProps = {
  results: any[];
  dataTableRef: React.MutableRefObject<DataTable>;
}

export function GlobalSearchResultGrid({ results, dataTableRef }: GlobalSearchResultGridProps) {
  const columnDefs = [
    {
      targets: 0, // reportId (available actions)
      createdCell: (td, cellData, rowData: GlobalSearchResult, row, col) => ReactDOM.render(
        <div>
          <Provider store={reduxStore}>
            <ViewAllButton reportId={rowData?.reportId} dbToSearch="private" />
            <CommentsButton
              reportId={rowData?.reportId}
              className='btn-sm ml-2'
              placement='right'
              report={rowData?.report} />
          </Provider>
        </div>,
        td
      ),
    },
    {
      targets: 1, // driverLicenseNumbers
      createdCell: (td, cellData: string[], rowData: GlobalSearchResult, row, col) => ReactDOM.render(
        <ul style={{ padding: 0, margin: 0 }}>
          {cellData.map(dln => (
            <li key={dln}>
              {dln}
            </li>
          ))}
        </ul>,
        td),
    },
    {
      targets: 2, // driver names
      createdCell: (td, cellData: string[], rowData: GlobalSearchResult, row, col) => ReactDOM.render(
        <ul style={{ padding: 0, margin: 0 }}>
          {cellData.map(driverName => (
            <li key={driverName}>
              {driverName}
            </li>
          ))}
        </ul>,
        td
      ),
    },
  ];

  const columns = [
    {
      title: "Available Actions",
      data: "reportId",
    },
    {
      title: "Driver License Number(s)",
      data: "driverLicenseNumbers",
    },
    {
      title: "Driver Name(s)",
      data: "driverNames",
    },
    {
      title: "Crash Date",
      mData: (data: GlobalSearchResult, type: string) => {
        switch (type) {
          case "sort":
            return new Date(data.dateOfCrash).toISOString();
          default:
            return data.dateOfCrash;
        }
      }
    },
    {
      title: "Static Crash Key",
      data: "originalCrashKey",
    },
    {
      title: "Report Type",
      data: "reportType",
    },
    {
      title: "Street Name",
      data: "streetNameOrHighwayNumber",
    },
    {
      title: "County",
      data: "county",
    },
    {
      title: "Agency Case Number",
      data: "agencyCaseNumber",
    },
  ];


  return (
    <DataTable
      id="tblGlobalSearch"
      data={results}
      columns={columns}
      columnDefs={columnDefs}
      actionsColumn="first"
      searching={false}
      ref={dataTableRef} />
  );
}
